import { onIdentityChange } from "./identity";
import { endAllRoomSessions } from "./room-session";

export { createIdentityWatcher } from "./identity";

let installed = false;

/**
 * End every room session when the signed-in identity changes. Without this a
 * session outlives sign-out: its next heartbeat 401s, the refresh fails and the
 * API client hard-reloads to /login. After a persona switch the seat belongs to
 * the old persona, so heartbeating it as the new one is wrong too. Idempotent.
 */
export function installRoomSessionTeardown(): void {
  if (installed) return;
  installed = true;
  onIdentityChange(endAllRoomSessions);
}
